import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { FeatureEntitlements } from './featureEntitlements'

export const lifecycleCrmAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.lifecycleCrmEnabled],
    permissions: [], // TODO: Figure out what roles/permissions are needed for this feature.
    featureEntitlementIds: [FeatureEntitlements.LifecycleCRM],
    minICPlatformVersion: ICPlatformVersion.r2026_03_0,
  },
]
